import {useTranslation} from "react-i18next";
import {Blockquote, Form, InputGroup} from "@wfp/ui";
import {SMETSTextInput} from "../commons/text-input";
import {Supplier} from "../../models/types";
import {SupplierError} from "../../models/validate-supplier";

interface Props {
    supplier: Supplier;
    error?: SupplierError;
    onChange: (u: Supplier) => void
}

export const SupplierForm = (props: Props) => {
    const {t} = useTranslation();
    return (
        <Form>
            {!!(props.error?.detail) && (
                <Blockquote kind="error" withIcon>
                    {t(props?.error?.detail?.toString() || '')}
                </Blockquote>
            )}
            <InputGroup>
                <div className='flex flex-col w-full items-start'>
                    <div className={`w-3/4 ${!!props.error?.nameAr ? 'mb-10' : 'mb-3'}`}>
                        <SMETSTextInput
                            required
                            type='text'
                            value={props.supplier.nameAr}
                            invalid={!!props.error?.nameAr}
                            invalidText={t(props.error?.nameAr?.toString() || '')}
                            name='nameAr'
                            onChange={(e: any) => props.onChange({...props.supplier, nameAr: e.target.value})}
                            labelText={t("nameAr?")!}
                        />
                    </div>
                    <div className={`w-3/4 ${!!props.error?.nameEn ? 'mb-10' : 'mb-3'}`}>
                        <SMETSTextInput
                            required
                            type='text'
                            value={props.supplier.nameEn}
                            invalid={!!props.error?.nameEn}
                            invalidText={t(props.error?.nameEn?.toString() || '')}
                            name='nameEn'
                            onChange={(e: any) => props.onChange({...props.supplier, nameEn: e.target.value})}
                            labelText={t("nameEn?")!}
                        />
                    </div>
                    <div className={`w-3/4 ${!!props.error?.phone ? 'mb-10' : 'mb-3'}`}>
                        <SMETSTextInput
                            required={false}
                            type='text'
                            value={props.supplier.phone}
                            invalid={!!props.error?.phone}
                            invalidText={t(props.error?.phone?.toString() || '')}
                            name='phone'
                            onChange={(e: any) => props.onChange({...props.supplier, phone: e.target.value})}
                            labelText={t("phone?")!}
                        />
                    </div>
                </div>
            </InputGroup>
        </Form>
    )
}
